import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {
    createMetSelectWrapper,
    MetSelectInput,
    MetSelectList,
} from 'topmeteo/general/components/MetSelectWrapper';

import {changeResolution} from '../../actionCreators';
import {getResolution} from '../../selectors';

import ResolutionItem from './ResolutionItem';

const OptGroupLabel = gettext('Forecast Resolution');

const ResolutionSelect = ({resolutions, resolution, label, onChange, ...props}) => (
    <div className="met-select-wrapper right-menu-icon">
        <select className="met-select" value={resolution} onChange={onChange}>
            <optgroup label={OptGroupLabel}>
                {resolutions.map(({label, ...resolution}) => <option {...resolution}>{label}</option>)}
            </optgroup>
        </select>
        <div className="styled-dropdown">
            <MetSelectInput {...props} value={label} />
            <MetSelectList>
                {resolutions.map(resolution => <ResolutionItem {...resolution} />)}
            </MetSelectList>
        </div>
    </div>
);

const ResolutionSelectWrapper = createMetSelectWrapper(ResolutionSelect);

const mapStateToProps = state => {
    const {resolution, resolutions} = state;
    const {label} = getResolution(state);

    return {
        label,
        resolution,
        resolutions,
    };
};

const mapDispatchToProps = dispatch => ({
    onChange: ({target: {value}}) => dispatch(changeResolution(+value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResolutionSelectWrapper);
